// @flow
import styled from 'styled-components';
import * as React from 'react';
import { below } from '../../assets/css/media';
import colors from '../../assets/css/colors';
import {
	RotatedLabel,
	PlayerTableCell,
	PlayerInfo,
	FilledIcon
} from '../';
import Revert from '../Icons/Revert';
import { TradeCell } from './TradeCell';

const InCellStyled = styled(TradeCell)`
	background: rgba(246,246,246,0.5);
	.filled-icon {
		margin-left: auto;
		margin-right: 4em;
		${below.desktop`
			margin-right: 1em;
		`}
	}
`;

const StyledPlayerTableCell = styled(PlayerTableCell)`
	width: 260px;
	${below.desktop`
		width: 40vw;
	`}
`;

type TCell = {
	removePlayer?: Function,
	player: Object
};
export const HistoryTradeInCell = ({ player, removePlayer }: TCell) => {
	return (
		<InCellStyled>
			<StyledPlayerTableCell height="60px" justify="flex-start">
				<RotatedLabel
					background={colors.liveGreen}
					text="IN"
					border_radius="2px 0 0 2px"
					rotate="-90" />
				<PlayerInfo player={player} />
			</StyledPlayerTableCell>
			{removePlayer ? (
				<FilledIcon
					onClick={() => removePlayer({ id: player.id })}
					background={colors.red}
					className="filled-icon"
				>
					<Revert color="#fff" />
				</FilledIcon>
			) : null}
		</InCellStyled>
	);
};

export default HistoryTradeInCell;


// WEBPACK FOOTER //
// ./src/components/Trades/HistoryTradeInCell.js